/**
 * カテゴリー
 */
import Vue from "vue";
import * as types from "../../../mutation-types/backyard-types";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/search/categories`

const category = {
    namespaced: true,
    state: {
        content: [],
    },
    getters: {},
    actions: {
        fetch({ commit }) {

            return new Promise((resolve, _reject) => {
                Vue.$http.get(API_PATH).then(data => {
                    let content = data.content
                    commit(types.BACK_SEARCH_CATEGORY, { content })
                    resolve(content)
                })
            })
        }
    },
    mutations: {
        [types.BACK_SEARCH_CATEGORY] (state, { content }) {
            state.content = content
        },
    },
}

export default category
